import { Inject, Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root',
})
export class EventsService {
  private readonly eventsBaseApiUrl: string;

  constructor(@Inject('BASE_URL') baseUrl: string, private dataService: DataService) {
    this.eventsBaseApiUrl = `${baseUrl}api/events`;
  }

  public getEvents(industry: string) {
    let eventsApiUrl = `${this.eventsBaseApiUrl}/${industry}`;

    return this.dataService.get<any>(eventsApiUrl);
  }
}
